import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { getIn, useFormik } from "formik";

import FormInput from "components/forms/components/formInput";

const MMSSetting = forwardRef(function MMSSetting(props, ref) {
  const { isView, serviceSelected } = props;
  const { t } = useTranslation();
  const [mmsSettingValues, setMmsSettingValues] = useState(null);

  const onSubmitForm = async data => {
    setMmsSettingValues(data);
  };

  const mmsSettingForm = useFormik({
    initialValues: {
      sendMMS: serviceSelected?.sendReceiveMms
        ? serviceSelected?.sendReceiveMms
        : false,
      receiveMMS: true,
    },
    onSubmit: onSubmitForm,
  });

  const { values, setFieldValue, handleSubmit } = mmsSettingForm;

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      handleSubmit();
    },
    mmsSettingValues: mmsSettingValues,
  }));

  const mmsSettingInputItems = [
    {
      type: "switch",
      key: "sendMMS",
      label: t("numbers.sendMultimediaContent"),
      span: 24,
      colon: false,
      disabled: isView,
      style: {
        marginBottom: 0,
        textAlign: "right",
      },
    },
    {
      type: "switch",
      key: "receiveMMS",
      label: t("numbers.allowReceivingMultimediaContent"),
      span: 24,
      colon: false,
      disabled: true,
      style: {
        marginBottom: 0,
        textAlign: "right",
      },
    },
  ];
  return (
    <>
      <FormInput
        items={mmsSettingInputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={mmsSettingForm}
        onChange={setFieldValue}
      />
    </>
  );
});

export default MMSSetting;
